<template>
    <div class="mt-15">
        <div v-if="bloqueo==0">
            <v-row>
                <v-col cols="12" class="mt-10 text-center">
                    <img src="@/assets/denegado.png" />
                </v-col>
            </v-row>
        </div>
        <div v-else-if="bloqueo==1">
            <v-container>
                <v-row class="mt-2">
                    <v-col cols="12" md="7">
                        <v-sheet style="border:1px solid lightgray" width="100%" rounded="xl">
                            <v-container>
                                <v-row>
                                    <v-col cols="12" md="6" class="d-flex">
                                        <h5 class="mt-1">Selecciona Profesional</h5>
                                        <v-btn v-if="btn_modifica!=true" @click="d_profesional=true" class="ml-5" x-small color="indigo" dark rounded fab><v-icon small>find_replace</v-icon></v-btn>
                                        <v-btn v-else class="ml-5" x-small color="grey" dark rounded fab><v-icon small>find_replace</v-icon></v-btn>
                                    </v-col>
                                    <v-col cols="12" md="6" class="text-end">
                                        <v-btn @click="open_liquida()" color="warning" x-small rounded dark>&nbsp;&nbsp;&nbsp;Modificar Liquidación&nbsp;&nbsp;&nbsp;</v-btn>
                                    </v-col>
                                </v-row>
                                <v-row class="mt-8">
                                    <v-col cols="12" md="4" class="mt-n7">
                                        <v-text-field label="Usuario" class='text-body-2' v-model="usuario" dense outlined rounded disabled></v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="8" class="mt-n7">
                                        <v-text-field label="Nombre" class='text-body-2' v-model="nombre" dense outlined rounded disabled></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-sheet>
                    </v-col>
                    <v-col cols="12" md="5">
                        <v-sheet style="border:1px solid lightgray" width="100%" rounded="xl">
                            <v-container>
                                <v-row>
                                    <v-col cols="12" md="12" class="d-flex">
                                        <h5 class="mt-1">Periodo Liquidación</h5>
                                    </v-col>
                                </v-row>
                                <v-row class="mt-5">
                                    <v-col cols="12" md="2" class="mt-n5">
                                        <v-icon>event</v-icon>
                                    </v-col>
                                    <v-col cols="12" md="5" class="mt-n5">
                                        <v-select class='text-caption' v-model="anio" :items="anio_periodo" label="Año" dense outlined rounded></v-select>
                                    </v-col>
                                    <v-col cols="12" md="5" class="mt-n5">
                                        <v-select class='text-caption' v-model="mes" :items="meses" label="Mes" item-text="text" item-value="value" dense outlined rounded></v-select>
                                    </v-col>
                                    <v-col cols="12" md="12" class="mt-n8 text-end">
                                        <v-btn v-if="btn_modifica!=true" @click="search_liquida()" color="indigo" x-small rounded dark>&nbsp;&nbsp;&nbsp;buscar servicios&nbsp;&nbsp;&nbsp;</v-btn>
                                        <v-btn v-else color="grey" x-small rounded dark>&nbsp;&nbsp;&nbsp;buscar servicios&nbsp;&nbsp;&nbsp;</v-btn>
                                    </v-col>
                                </v-row>
                                <!-- <v-row class="mt-10">
                                    <v-col cols="12" md="6" class="mt-n7">
                                        <v-menu v-model="menu1" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field v-model="date1" label="Desde" prepend-icon="event" readonly v-bind="attrs" v-on="on" dense outlined rounded :disabled="disabled_data"></v-text-field>
                                            </template>
                                            <v-date-picker v-model="date1" @input="menu1 = false"></v-date-picker>
                                        </v-menu>
                                    </v-col>
                                    <v-col cols="12" md="6" class="mt-n7">
                                        <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field v-model="date2" label="Hasta" prepend-icon="event" readonly v-bind="attrs" v-on="on" dense outlined rounded :disabled="disabled_data"></v-text-field>
                                            </template>
                                            <v-date-picker v-model="date2" @input="menu2 = false"></v-date-picker>
                                        </v-menu>
                                    </v-col>
                                    <v-col cols="12" md="12" class="mt-n7 text-end">
                                        <v-btn v-if="btn_modifica!=true" @click="search_liquida()" color="indigo" x-small rounded dark>&nbsp;&nbsp;&nbsp;buscar servicios&nbsp;&nbsp;&nbsp;</v-btn>
                                        <v-btn v-else color="grey" x-small rounded dark>&nbsp;&nbsp;&nbsp;buscar servicios&nbsp;&nbsp;&nbsp;</v-btn>
                                    </v-col>
                                </v-row>                                 -->
                            </v-container>
                        </v-sheet>                    
                    </v-col>
                </v-row>
                <h5 class="mt-5">DETALLE DE SERVICIOS</h5>
                <v-row>
                    <v-col cols="12" md="8">
                        <v-simple-table fixed-header dense height="275" style="border:1px solid lightgray" class="text-size">
                            <thead>
                                <tr>
                                    <th style="background-color: lightgrey;">Fecha</th>
                                    <!-- <th style="background-color: lightgrey;">Comanda</th> -->
                                    <th style="background-color: lightgrey;">Cliente</th>
                                    <th class="text-end" style="background-color: lightgrey;">Servicio</th>
                                    <th style="background-color: lightgrey;">Forma</th>
                                    <th class="text-end" style="background-color: lightgrey;">Descuento</th>
                                    <th class="text-end" style="background-color: lightgrey;">Liquidación</th>
                                    <th class="text-center" style="background-color: lightgrey;">Pago 30%</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in myServicios" :key="item.ID">
                                    <td><span>{{ item.Fecha }}</span></td>
                                    <!-- <td><span>{{ item.Comanda }}</span></td> -->
                                    <td><span>{{ item.Cliente }}</span></td>
                                    <td class="text-end"><span>{{ new Intl.NumberFormat("de-DE").format(parseFloat(item.Total_Servicio)) }}</span></td>
                                    <td><span>{{ item.Forma }}</span></td>
                                    <td class="text-end"><span>{{ new Intl.NumberFormat("de-DE").format(parseFloat(item.Desc_Tarjeta)) }}</span></td>
                                    <td class="text-end"><span>{{ new Intl.NumberFormat("de-DE").format(parseFloat(item.Ingreso_Profesional)) }}</span></td>
                                    <td class="text-end">
                                        <span>{{ new Intl.NumberFormat("de-DE").format(parseFloat(item.Ingreso_Local)) }}</span>
                                        <v-icon @click="open_estado(item)" v-if="item.Forma=='Cobro Directo' && item.Estado=='Pagado'" class="ml-2" small color="success">check_box</v-icon>
                                        <v-icon @click="suma_ck(item)" v-else-if="item.Forma=='Cobro Directo' && item.Estado=='Pendiente'" class="ml-2" small color="error">check_box_outline_blank</v-icon>
                                        <v-icon @click="resta_ck(item)" v-if="item.Forma=='Cobro Directo' && item.Estado=='Recauda'" class="ml-2" small color="warning">check_box</v-icon>
                                        <!-- <v-icon @click="open_estado(item)" v-if="item.Forma=='Cobro Directo' && item.Estado=='Pagado'" class="ml-2" small color="success">check_circle</v-icon>
                                        <v-icon @click="open_estado(item)" v-if="item.Forma=='Cobro Directo' && item.Estado=='Pendiente'" class="ml-2" small color="error">cancel</v-icon> -->
                                        <v-icon v-if="item.Forma!='Cobro Directo'" class="ml-2" small color="grey">not_interested</v-icon>
                                    </td>
                                    <!-- <td v-if="parseFloat(item.Ingreso_Profesional)>=0" class="text-end"><span>{{ new Intl.NumberFormat("de-DE").format(parseFloat(item.Ingreso_Profesional)) }}</span></td>
                                    <td v-else class="text-end"><span class="red--text">{{ new Intl.NumberFormat("de-DE").format(parseFloat(item.Ingreso_Profesional)) }}</span></td> -->
                                </tr>
                            </tbody>
                        </v-simple-table>
                        <v-row class="mt-2">
                            <v-col cols="12" md="3">
                                <v-btn v-if="parseFloat(total_recauda)!=0" @click="pagar_recauda()" color="teal" small rounded dark>Pagar Recaudación</v-btn>
                                <v-btn v-else color="grey" small rounded dark>Pagar Recaudación</v-btn>
                            </v-col>
                            <v-col cols="12" md="3">
                                <v-select v-if="parseFloat(total_recauda)!=0" class='mt-0 text-caption' style="background-color: beige; height: 30px;" v-model="forma_recauda" :items="myFormaRecauda" placeholder="Forma de Pago" item-text="name" item-value="name" dense rounded></v-select>
                                <v-select v-else class='mt-0 text-caption' style="background-color: lightgray; height: 30px;" placeholder="Forma de Pago" v-model="forma_recauda" dense rounded readonly></v-select>
                            </v-col>
                            <v-col cols="12" md="3"></v-col>
                            <v-col cols="12" md="3" class="text-end">
                                <v-text-field label="Recaudación" style="background-color: lightgray; height: 30px;" class='text-body-2 black--text' v-model="txt_recauda" dense rounded readonly></v-text-field>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-sheet style="border:1px solid lightgray" height="80" width="100%" rounded="xl">
                            <v-container>
                                <h5 class="grey--text">Cobro Directo</h5>
                                <v-row>
                                    <v-col cols="4" class="text-center">
                                        <h5>Servicios</h5>
                                        <h5 class="brown--text">{{ new Intl.NumberFormat("de-DE").format(parseFloat(cantidad_cobro_Directo)) }}</h5>                                        
                                    </v-col>
                                    <v-col cols="4" class="text-center">
                                        <h5>
                                            <v-icon class="mt-n1" color="success" small>check_circle</v-icon>
                                            Pagos
                                        </h5>
                                        <h5 class="brown--text">${{ new Intl.NumberFormat("de-DE").format(parseFloat(total_pagos)) }}</h5>
                                    </v-col>
                                    <v-col cols="4" class="text-center">
                                        <h5>
                                            <v-icon class="mt-n1" color="error" small>cancel</v-icon>
                                            Pendiente
                                        </h5>
                                        <h5 class="brown--text">${{ new Intl.NumberFormat("de-DE").format(parseFloat(total_pendiente)) }}</h5>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-sheet>
                        <v-sheet class="mt-2" style="border:1px solid lightgray" height="200" width="100%" rounded="xl">
                            <v-container>
                                <!-- <h5 class="grey--text">Resumen Liquidación</h5> -->
                                <v-row>
                                    <v-col cols="6" class="text-start">
                                        <h5>Total Producción</h5>
                                    </v-col>
                                    <v-col cols="6" class="text-end">
                                        <h5 class="brown--text">${{ new Intl.NumberFormat("de-DE").format(parseFloat(total_produccion)) }}</h5>
                                    </v-col>
                                </v-row>
                                <v-row class="mt-n5">
                                    <v-col cols="6" class="text-start">
                                        <h5>Total Servicios</h5>
                                    </v-col>
                                    <v-col cols="6" class="text-end">
                                        <h5 class="brown--text">{{ new Intl.NumberFormat("de-DE").format(parseFloat(cantidad_servicios)) }}</h5>
                                    </v-col>
                                </v-row>
                                <v-row class="mt-n5">
                                    <v-col cols="6" class="text-start">
                                        <h5>70% Otros MP</h5>
                                    </v-col>
                                    <v-col cols="6" class="text-end">
                                        <h5 class="brown--text">${{ new Intl.NumberFormat("de-DE").format(parseFloat(total_otros_MP)) }}</h5>
                                    </v-col>
                                </v-row>
                                <v-row class="mt-n5">
                                    <v-col cols="6" class="text-start">
                                        <h5>Servicios otros MP</h5>
                                    </v-col>
                                    <v-col cols="6" class="text-end">
                                        <h5 class="brown--text">{{ new Intl.NumberFormat("de-DE").format(parseFloat(cantidad_otro_MP))}}</h5>
                                    </v-col>
                                </v-row>
                                <v-row class="mt-n5">
                                    <v-col cols="6" class="text-start">
                                        <h5>30% Pendiente</h5>
                                    </v-col>
                                    <v-col cols="6" class="text-end">
                                        <h5 class="error--text">( ${{ new Intl.NumberFormat("de-DE").format(parseFloat(total_pendiente)) }} )</h5>
                                    </v-col>
                                </v-row>
                                <v-row class="mt-n5">
                                    <v-col cols="6" class="text-start">
                                        <h5>Anticipo</h5>
                                    </v-col>
                                    <v-col cols="6" class="text-end">
                                        <h5 class="error--text">( ${{ new Intl.NumberFormat("de-DE").format(parseFloat(total_anticipo)) }} )</h5>
                                    </v-col>
                                </v-row>
                                <v-row class="mt-n2">
                                    <v-col cols="6" md="6">
                                        <h5>Total Liquidación</h5>
                                    </v-col>
                                    <v-col cols="6" md="6" class="text-end">
                                        <h3 v-if="parseFloat(total_ingreso)>=0" class="mt-n1 brown--text">${{ new Intl.NumberFormat("de-DE").format(parseFloat(total_ingreso)) }}</h3>
                                        <h3 v-else class="mt-n1 error--text">( ${{ new Intl.NumberFormat("de-DE").format(parseFloat(Math.abs(total_ingreso))) }} )</h3>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-sheet>
                        <!-- <v-sheet class="mt-2" style="border:1px solid lightgray" height="100" width="100%" rounded="xl">
                            <v-container>
                                <v-row>
                                    <v-col cols="6" md="6">
                                        <h5 class="grey--text">Últimas Liquidaciones</h5>
                                    </v-col>
                                </v-row>
                                <v-row v-for="item in myLiquida" :key="item.ID" class="mt-7">
                                    <v-col cols="6" md="6" class="mt-n7">
                                        <h6 class="grey--text">{{ item.Periodo }}</h6>
                                    </v-col>
                                    <v-col cols="6" md="6" class="mt-n7 text-end">
                                        <h6 class="grey--text">${{ new Intl.NumberFormat("de-DE").format(parseFloat(item.Ingreso)) }}</h6>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-sheet> -->
                        <!-- <v-sheet class="mt-2" style="border:1px solid lightgray" height="110" width="100%" rounded="xl">
                            <v-container>
                                <v-row class="mt-1">
                                    <v-col cols="6" md="6">
                                        <h5>Total Anticipo</h5>
                                    </v-col>
                                    <v-col cols="6" md="6" class="text-end">
                                        <h5 class="mt-1 grey--text">( ${{ new Intl.NumberFormat("de-DE").format(parseFloat(total_anticipo)) }} )</h5>
                                    </v-col>
                                </v-row>
                                <v-row class="mt-n2">
                                    <v-col cols="6" md="6">
                                        <h5>Total Liquidación</h5>
                                    </v-col>
                                    <v-col cols="6" md="6" class="text-end">
                                        <h2 class="mt-n2">${{ new Intl.NumberFormat("de-DE").format(parseFloat(total_ingreso)) }}</h2>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-sheet> -->
                        <v-row class="mt-7">
                            <v-col cols="5" md="5" class="mt-n7">
                                <v-btn @click="clsInput()" color="teal" small rounded block dark>Limpiar</v-btn>
                            </v-col>
                            <v-col cols="7" md="7" class="mt-n7">
                                <div v-if="btn_modifica!=false">
                                    <v-btn v-if="btn_venta!=true" @click="modifica_liquida()" color="error" small rounded block dark>anular liquidación</v-btn>
                                    <v-btn v-else color="grey" small rounded block dark>anular Liquidación</v-btn>
                                </div>
                                <div v-else>
                                    <v-btn v-if="btn_venta!=true" @click="save_liquida()" color="teal" small rounded block dark>generar Liquidación</v-btn>
                                    <v-btn v-else color="grey" small rounded block dark>generar Liquidación</v-btn>
                                </div>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-container>
        </div>
            <div style="height: 50px;"></div>
            <v-footer height="50" color="#c1680e" fixed></v-footer>

        <v-dialog v-model="d_profesional" persistent max-width="600">
            <v-card color="#fff" rounded>
                <v-card-title>
                    Profesionales
                    <v-spacer></v-spacer>
                    <v-icon @click="d_profesional=false">close</v-icon>
                </v-card-title>
                <v-card-text>
                    <v-simple-table fixed-header dense height="300">
                            <thead>
                                <tr>
                                    <th style="background-color: lightgrey;">Usuario</th>
                                    <th style="background-color: lightgrey;">Nombre</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr @click="handProfesional(item)" v-for="item in myProfesional" :key="item.ID">
                                    <td><span class="text-body-2">{{ item.usuario }}</span></td>
                                    <td><span class="text-body-2">{{ item.nombre }}</span></td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog v-model="d_liquida" persistent max-width="300">
            <v-card color="#fff" rounded="xl">
                <v-card-title>
                    Modificar Liquidación
                    <v-spacer></v-spacer>
                    <v-icon @click="close_liquida()">close</v-icon>
                </v-card-title>
                <v-card-text>
                    <v-row class="mt-2">
                        <v-col cols="12" class="text-center">
                            <v-text-field label="N° Liquidación" type="number" class='text-body-2' v-model="numero" dense outlined rounded></v-text-field>
                        </v-col>
                        <v-col cols="12" class="mt-n7 text-center">
                            <v-btn @click="search_number()" color="teal" small rounded block dark>buscar número</v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>
        
        <v-dialog v-model="loading" persistent max-width="300">
            <v-card color="#fff" rounded="xl">
                <v-card-text>
                    <v-row class="mt-2">
                        <v-col cols="12" class="text-center">
                            <h3 class="mb-2">Procesando ...</h3>
                            <v-progress-linear indeterminate color="red"></v-progress-linear>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog v-model="d_estado" persistent max-width="300">
            <v-card color="#fff" rounded="xl">
                <v-card-title>
                    Estado de Pago
                    <v-spacer></v-spacer>
                    <v-icon @click="d_estado=false">close</v-icon>
                </v-card-title>
                <v-card-text class="mt-n2">
                    <v-container>
                        <v-divider></v-divider>
                        <v-row class="mt-n2">
                            <v-col cols="12" class="text-center">
                                <v-radio-group v-model="radios">
                                    <v-radio value="Pagado" color="success">
                                        <template v-slot:label>
                                        <div><strong class="success--text">Pagado</strong></div>
                                        </template>
                                    </v-radio>
                                    <v-radio value="Pendiente" color="error">
                                        <template v-slot:label>
                                        <div><strong class="error--text">Pendiente</strong></div>
                                        </template>
                                    </v-radio>
                                </v-radio-group>
                            </v-col>
                        </v-row>
                        <v-row class="mt-n5">
                            <v-col cols="12">
                                <v-select class='text-caption' v-model="forma" :items="myFormaPago" label="Forma de Pago" item-text="name" item-value="name" dense outlined rounded></v-select>
                            </v-col>
                        </v-row>
                        <v-row class="mt-n5">
                            <v-col cols="12" class="text-center">
                                <v-btn @click="change_estado()" small class="teal" dark>Cambiar Estado</v-btn>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-dialog>


        <img id="logo_solarium" src="@/assets/logo_solarium.jpg" height="0" width="0">             

        <v-snackbar v-model="snack" timeout="3000" :color="color_snack">
            <div class="d-flex justify-center">                
                <h4>{{mensaje}}</h4>
            </div>
        </v-snackbar>
    </div>
</template>
<style scoped>
.text-size >>> td {
    font-size: 9pt !important;
    height: 25px !important;
    /* background-color: lightyellow; */
}
</style>
<script>
import axios from "axios";
import { jsPDF } from "jspdf";
export default {
    name: 'Liquidacion',
    data: () => ({
        contrato:null,
        user:null,
        apikey:null,
        snack:false,
        color_snack:'',
        mensaje:'',
        bloqueo:null,
        loading:false,

        menu1:false,
        date1: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substring(0, 10),
        menu2:false,
        date2: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substring(0, 10),
        usuario:'',
        nombre:'',
        comision:0,
        d_profesional:false,
        myProfesional:[],
        myServicios:[],
        myLiquida:[],
        myVentas:[],
        myAnticipos:[],
        total_anticipo:0,
        total_produccion:0,
        total_descuento:0,
        total_egreso:0,
        total_ingreso:0,
        disabled_data:false,
        btn_venta:false,
        numero_folio:0,
        //modificar
        d_liquida:false,
        numero:0,
        btn_modifica:false,
        //periodo
        anio_periodo:[],
        anio:'',
        mes:'',
        meses:[
            {text:'ENERO', value:1},
            {text:'FEBRERO', value:2},
            {text:'MARZO', value:3},
            {text:'ABRIL', value:4},
            {text:'MAYO', value:5},
            {text:'JUNIO', value:6},
            {text:'JULIO', value:7},
            {text:'AGOSTO', value:8},
            {text:'SEPTIEMBRE', value:9},
            {text:'OCTUBRE', value:10},
            {text:'NOVIEMBRE', value:11},
            {text:'DICIEMBRE', value:12},
        ],
        d_estado:false,
        radios:null,
        array_estado:[],
        forma:'',
        myFormaPago:[],
        observa:'',

        cantidad_cobro_Directo:0,
        cantidad_otro_MP:0,
        cantidad_servicios:0,

        total_pagos:0,
        total_pendiente:0,
        total_otros_MP:0,

        array_recauda:[],
        total_recauda:0,
        txt_recauda:'0',
        forma_recauda:'',
        observa_recauda:'',
        myFormaRecauda:['Transferencia', 'Efectivo'],

    }),
    async mounted(){
        const myToken = localStorage.getItem('mytoken');
        const myUser = localStorage.getItem('myuser');
        const myContrato = localStorage.getItem('mycontrato');
        const myTime = localStorage.getItem('timeuser');
        if(myToken!=null && myUser!=null && myContrato!=null){
        //verificamos la expiracion
        const ahora = new Date();
        const expira = new Date(myTime);
        if(ahora > expira){
            this.goLogin()
        } else {
            this.apikey = myToken;
            this.contrato = myContrato;
            this.user = myUser;
            this.loading=true;
            this.bloqueo = await this.myPermiso(5);
            if(parseInt(this.bloqueo)!=0){
                await this.crearPeriodos();
                await this.search_users();
                await this.search_formas();
            };
            this.loading=false
        }
        } else {
            this.goLogin();
        }
    },
    methods:{
        async search_formas(){
            try {
                const headers = {
                    'Content-Type': 'application/json',
                    'Authorization': 'Token ' + this.apikey
                };
                const params = {
                    'contrato' : this.contrato,
                    'user' : this.user,
                    'forma' : 'all'
                };
                const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/type/payments/',params,{headers});
                const datos = res.data;
                if(datos[0].existe=='si'){
                    datos.forEach(element => {
                        this.myFormaPago.push({
                            'name': element.Forma,
                            'comis': element.Comision
                        })
                    });
                }
            } catch (error) {
                console.log(error)
            }
        },
        async open_estado(item){
            console.log(item);
            this.array_estado = item;
            this.radios = item.Estado;
            this.forma = '';
            this.d_estado = true;
        },
        async change_estado(){
            if(this.array_estado.length!=0){
                const myEstado = this.array_estado.Estado;
                if(myEstado!=this.radios){
                    let cerrar = 'no'
                    this.loading=true;
                    if(this.radios=='Pagado'){
                        //save
                        if(this.forma!=null && this.forma!=''){
                            await this.save_pago();
                            cerrar='si';
                        } else {
                            this.color_snack='error';
                            this.mensaje='Ingrese forma de pago';
                            this.snack=true
                            cerrar='no';
                        }
                    }
                    if(this.radios=='Pendiente'){
                        //delete
                        await this.delete_pago();
                        cerrar='si';
                    };
                    //refrescamos la lista
                    await this.search_liquida();
                    this.loading=false;
                    if(cerrar=='si'){
                        this.d_estado=false;
                    }
                } else {
                    this.d_estado=false;
                }
            };
        },
        async save_pago(){
            const element = this.array_estado;
            try {
                const headers = {
                    'Content-Type': 'application/json',
                    'Authorization': 'Token ' + this.apikey
                };
                const params = {
                    'contrato' : this.contrato,
                    'user' : this.user,
                    'profesional': element.Profesional,
                    'comanda': element.Comanda,
                    'total': element.Ingreso_Local,
                    'forma': this.forma,
                    'observa': this.observa
                }
                const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/save/payment/',params,{headers});
                const datos = res.data;
                if(datos[0].existe=='si'){
                    console.log('pago registrado correctamente')
                } else {
                    console.log('pago NO registrado')
                }
            } catch (error) {
                console.log(error)
            }
        },
        async delete_pago(){
            const element = this.array_estado;
            try {
                const headers = {
                    'Content-Type': 'application/json',
                    'Authorization': 'Token ' + this.apikey
                };
                const params = {
                    'contrato' : this.contrato,
                    'user' : this.user,
                    'id_comanda': element.Comanda,
                }
                const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/delete/payment/',params,{headers});
                const datos = res.data;
                if(datos[0].existe=='si'){
                    console.log('pago eliminado correctamente')
                } else {
                    console.log('pago NO eliminado')
                }                
            } catch (error) {
                console.log(error)
            }
        },
        async totales_pagos(){
            this.total_pagos=0;
            this.total_pendiente=0;
            if(this.myServicios.length!=0){
                this.myServicios.forEach(element => {
                    if(element.Forma=='Cobro Directo'){
                        if(element.Estado=='Pagado'){
                            this.total_pagos=parseFloat(this.total_pagos) + parseFloat(element.Ingreso_Local);
                        }
                        if(element.Estado=='Pendiente'){
                            this.total_pendiente=parseFloat(this.total_pendiente) + parseFloat(element.Ingreso_Local);
                        }
                    }
                });
            };
            //descontamos el pendiente de pago al total de ingreso
            this.total_ingreso = parseFloat(this.total_otros_MP) - (parseFloat(this.total_anticipo)); //+ parseFloat(this.total_pendiente;
        },
        async crearPeriodos(){
            let today = new Date();
            let year = today.getFullYear();
            this.anio = year;
            this.mes = today.getMonth() + 1
            //iterar hacia atras
            let year_menos = 0;
            for (let index = 1; index > 0; index--) {
                year_menos = year - index;
                this.anio_periodo.push( year_menos );
            };
            this.anio_periodo.push( year );        
        },
        open_liquida(){
            this.clsInput();
            this.btn_modifica=true;
            this.d_liquida=true;
        },
        close_liquida(){
            this.clsInput();
            this.btn_modifica=false;
            this.d_liquida=false;
        },
        clsInput(){
            this.date1=(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substring(0, 10);
            this.date2=(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substring(0, 10);
            this.usuario='';
            this.nombre='';
            this.comision=0;
            this.myServicios=[];
            this.myLiquida=[];
            this.myVentas=[];
            this.myAnticipos=[];
            this.total_produccion=0;
            this.total_descuento=0;
            this.total_anticipo=0;
            this.total_egreso=0;
            this.total_ingreso=0;
            this.btn_venta=false;
            this.disabled_data=false;
            this.numero_folio=0;
            this.numero=0;
            this.btn_modifica=false;
            this.cantidad_cobro_Directo=0;
            this.cantidad_otro_MP=0;
            this.cantidad_servicios=0;
            this.total_pagos=0;
            this.total_pendiente=0;
            this.total_otros_MP=0;
            this.array_recauda=[];
            this.total_recauda=0;
            this.txt_recauda='0';
            this.forma_recauda='';
        },
        goLogin(){
            localStorage.removeItem('mytoken');
            localStorage.removeItem('myuser');
            localStorage.removeItem('mycontrato');
            localStorage.removeItem('timeuser');
            this.$router.push({name:'Login'})
        },
        async myPermiso(id){
            let result = 0;
            try {
                const headers = {
                    'Content-Type': 'application/json',
                    'Authorization': 'Token ' + this.apikey
                };
                const params = {
                    'contrato' : this.contrato,
                    'user' : this.user,
                    'id' : id
                };
                const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/permission/',params,{headers});
                const datos = res.data;
                if(datos[0].existe=='si'){
                    result = parseInt(datos[0].acceso);
                }
            } catch (error) {
                console.log(error)
            }
            return result
        },
        async search_users(){
            try {
                const headers = {
                    'Content-Type' : 'application/json',
                    'Authorization' : 'Token ' + this.apikey
                };
                const params = {
                    'contrato' : this.contrato,
                    'user' :  this.user,
                    'usuario' :  'all'
                };
                const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/search/user/',params,{headers});
                const datos = res.data;
                if(datos[0].existe=='si'){
                    datos.forEach(element => {
                        if(element.tipo=='Profesional'){
                            this.myProfesional.push(element)
                        }
                    })
                }
            } catch (error) {
                console.log(error);
            }
        },
        async handProfesional(line){
            this.clsInput();
            this.usuario = line.usuario;
            this.nombre = line.nombre;
            this.comision = line.comision;
            this.d_profesional = false;
            //await this.search_liquidaciones(line.usuario);
        },
        async search_liquidaciones(myuser){
            this.myLiquida=[];
            try {
                const headers = {
                    'Content-Type' : 'application/json',
                    'Authorization' : 'Token ' + this.apikey
                };
                const params = {
                    'contrato' : this.contrato,
                    'user' :  this.user,
                    'usuario' :  myuser,
                    'periodos' :  3,
                };
                const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/history/liquida/',params,{headers});
                const datos = res.data;
                if(datos[0].existe=='si'){
                    this.myLiquida = datos;
                }
            } catch (error) {
                console.log(error)
            }
        },
        async search_liquida(){
            if(this.usuario!=''){
                this.loading=true;
                this.disabled_data=true;
                await this.search_servicios();
                await this.search_ventas();
                await this.search_anticipos();
                await this.process_liquida();
                await this.totales_pagos();
                this.loading=false;
            } else {
                this.color_snack='error';
                this.mensaje='Seleccione profesional para buscar servicios';
                this.snack=true
            }
        },
        async process_liquida(){
            try {
                let suma_produccion = 0;
                let suma_descuento = 0;
                let suma_egreso = 0;
                let suma_total = 0;
                this.cantidad_cobro_Directo=0;
                this.cantidad_otro_MP=0;
                this.cantidad_servicios=0;
                this.total_otros_MP=0;
                // obtener datos de los servicios
                this.myServicios.forEach(element => {
                    if(element.Forma=='Cobro Directo'){
                        this.cantidad_cobro_Directo = parseFloat(this.cantidad_cobro_Directo) + 1;
                    } else {
                        this.cantidad_otro_MP = parseFloat(this.cantidad_otro_MP) + 1;
                        this.total_otros_MP = parseFloat(this.total_otros_MP) + parseFloat(element.Ingreso_Profesional);
                    }
                    suma_produccion = parseFloat(suma_produccion) + parseFloat(element.Total_Servicio);
                    suma_descuento = parseFloat(suma_descuento) + parseFloat(element.Desc_Tarjeta);
                    suma_egreso = parseFloat(suma_egreso) + parseFloat(element.Ingreso_Local);
                    suma_total = parseFloat(suma_total) + parseFloat(element.Ingreso_Profesional)                        
                });
                this.cantidad_servicios = parseFloat(this.cantidad_cobro_Directo) + parseFloat(this.cantidad_otro_MP);
                // obtener datos de las ventas
                if(this.myVentas.length!=0){
                    this.myVentas.forEach(element => {
                        const fecha_venta = element.Fecha;
                        const sku_venta = element.Sku;
                        const producto_venta = element.Producto;
                        const total_venta = element.Total;
                        const comision_venta = parseFloat(parseFloat(total_venta) * (parseFloat(this.comision)/100)).toFixed(0);
                        const local_venta = parseFloat(parseFloat(total_venta) - (parseFloat(comision_venta))).toFixed(0);
                        this.myServicios.push({
                            'Fecha': fecha_venta,
                            'Cliente': 'Sku: ' + sku_venta,
                            'Servicio': sku_venta,
                            'Detalle': producto_venta,
                            'Forma': 'Comisión ' + this.comision + '%',
                            'Total_Servicio': total_venta,
                            'Desc_Tarjeta': 0,
                            // 'Ingreso_Local': local_venta,
                            'Ingreso_Local': 0,
                            'Ingreso_Profesional': comision_venta
                        });
                        suma_produccion = parseFloat(suma_produccion) + parseFloat(total_venta);
                        //suma_descuento = parseFloat(suma_descuento) + parseFloat(element.Desc_Tarjeta);
                        suma_egreso = parseFloat(suma_egreso) + parseFloat(local_venta);
                        suma_total = parseFloat(suma_total) + parseFloat(comision_venta) 
                    });                    
                }
                // obtener datos de anticipos
                if(this.myAnticipos.length!=0){
                    this.myAnticipos.forEach(element => {
                        suma_descuento = parseFloat(suma_descuento) + parseFloat(element.Monto);
                        suma_total = parseFloat(suma_total) - parseFloat(element.Monto) 
                    });
                }
                this.total_produccion = suma_produccion;
                this.total_descuento = suma_descuento;
                this.total_egreso = suma_egreso;
                //this.total_ingreso = suma_total;
            } catch (error) {
                console.log(error)
            }
        },
        async verifica_periodo(){
            let result = false;
            try {
                const headers = {
                    'Content-Type' : 'application/json',
                    'Authorization' : 'Token ' + this.apikey
                };
                const params = {
                    'contrato' : this.contrato,
                    'user' :  this.user,
                    'usuario' :  this.usuario,
                    'periodo': this.mes + '-'+ this.anio
                };
                const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/verify/liquida/',params,{headers});
                const datos = res.data;
                if(datos[0].existe=='si'){
                    result = true
                }
            } catch (error) {
                console.log(error)
            }
            return result
        },
        async search_servicios(){
            this.myServicios=[];
            const verifyPeriodo = await this.verifica_periodo();
            if(!verifyPeriodo) {
                try {
                    const headers = {
                        'Content-Type' : 'application/json',
                        'Authorization' : 'Token ' + this.apikey
                    };
                    const params = {
                        'contrato' : this.contrato,
                        'user' :  this.user,
                        'usuario' :  this.usuario,
                        'mes' :  this.mes,
                        'anio' :  this.anio,
                        'periodo': this.mes + '-'+ this.anio
                    };
                    const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/search/liquida/',params,{headers});
                    const datos = res.data;
                    console.log('servicios', datos);
                    if(datos[0].existe=='si'){
                        datos.forEach(element => {
                            if(element.Servicio!='SOLARIUM'){
                                this.myServicios.push(element)
                            }
                        });
                        //this.myServicios = datos;
                    }
                } catch (error) {
                    console.log(error)
                }
            } else {
                this.color_snack='error';
                this.mensaje='El periodo selecionado ya esta liquidado';
                this.snack=true                
            }
        },
        async search_ventas(){
            this.myVentas=[];
            try {
                const headers = {
                    'Content-Type' : 'application/json',
                    'Authorization' : 'Token ' + this.apikey
                };
                const params = {
                    'contrato' : this.contrato,
                    'user' :  this.user,
                    'usuario' :  this.usuario,
                    'mes' :  this.mes,
                    'anio' :  this.anio,
                    'periodo' :  this.mes + '-' + this.anio,
                };
                const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/search/ventas/',params,{headers});
                const datos = res.data;
                console.log('ventas',datos)
                if(datos[0].existe=='si'){
                    this.myVentas = datos;
                }                
            } catch (error) {
                console.log(error)
            }
        },
        async search_anticipos(){
            this.myAnticipos=[];
            this.total_anticipo=0;
            try {
                const headers = {
                    'Content-Type' : 'application/json',
                    'Authorization' : 'Token ' + this.apikey
                };
                const params = {
                    'contrato' : this.contrato,
                    'user' :  this.user,
                    'usuario' :  this.usuario,
                    'mes' :  this.mes,
                    'anio' :  this.anio,
                    'periodo' :  this.mes + '-' + this.anio,
                };
                const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/search/anticipos/',params,{headers});
                const datos = res.data;
                console.log('anticipos',datos)
                if(datos[0].existe=='si'){
                    this.myAnticipos = datos;
                    //sumar anticipos del periodo seleccionado
                    datos.forEach(element => {
                        this.total_anticipo = parseFloat(this.total_anticipo) + parseFloat(element.Monto);
                    });
                }                                
            } catch (error) {
                console.log(error)
            }
        },
        async save_liquida(){
            this.loading=true;
            if(parseFloat(this.total_produccion)!=0){
                if(parseFloat(this.total_pendiente)==0){
                    try {
                        //obtener el id_venta
                        const folio = await this.folio_liquida();
                        if(parseInt(folio)!=0){
                            const headers = {
                                'Content-Type' : 'application/json',
                                'Authorization' : 'Token ' + this.apikey
                            };
                            const params = {
                                'contrato' : this.contrato,
                                'user' : this.user,
                                'folio': folio,
                                'periodo' : this.mes + '-' + this.anio,
                                'mes' : this.mes,
                                'anio' : this.anio,
                                'profesional' : this.usuario,
                                'produccion' : this.total_produccion,
                                'descuento' : this.total_descuento,
                                'egreso' : this.total_egreso,
                                'ingreso' : this.total_ingreso
                            };
                            const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/save/liquida/',params,{headers});
                            const datos = res.data;
                            console.log('save liquida',datos)
                            if(datos[0].existe=='si'){
                                this.btn_venta=true;
                                this.color_snack='success';
                                this.mensaje='Liquidación generada con exito';
                                this.snack=true;
                                await this.create_PDF();
                            }
                        } else {
                            this.color_snack='error';
                            this.mensaje='Sin folios, intentelo mas tarde';
                            this.snack=true
                        }
                    } catch (error) {
                        console.log(error)
                    }
                } else {
                    this.color_snack='error';
                    this.mensaje='Pagos pendientes para liquidar';
                    this.snack=true
                }
            } else {
                this.color_snack='error';
                this.mensaje='Ingrese datos para liquidar';
                this.snack=true
            };
            this.loading=false;
        },

        //  async create_PDF(){
        //      try {
        //          //formateamos a 10 hojas la guia
        //          let hojas_array = [];
        //          const datos_detail = this.myServicios;
        //          if(datos_detail.length!=0){
        //          const hoja0 = datos_detail.slice(0, 30)
        //          hojas_array.push(hoja0);
        //          const hoja1 = datos_detail.slice(30, 60)
        //          hojas_array.push(hoja1);
        //          const hoja2 = datos_detail.slice(60,90 )
        //          hojas_array.push(hoja2);
        //          const hoja3 = datos_detail.slice(90, 120)
        //          hojas_array.push(hoja3);
        //          const hoja4 = datos_detail.slice(120, 150)
        //          hojas_array.push(hoja4);
        //          };
        //          //recorrer los array con datos
        //          let numero_hoja = 0;
        //          const doc = new jsPDF('p', 'mm', 'letter');
        //          for (let index = 0; index < hojas_array.length; index++) {
        //              const detail = hojas_array[index];
        //              if(detail.length!=0){
        //                  numero_hoja = numero_hoja + 1;
        //                  if(parseInt(numero_hoja) != 1) {
        //                  doc.addPage('p','mm','letter');
        //                  } 
        //                  await this.PDF(doc, detail);
        //              }
        //          }
        //          doc.output('dataurlnewwindow')
        //      } catch (error) {
        //          console.log(error);
        //      }
        //  },

        // async PDF(doc, detail){

        //     //const doc = new jsPDF('p', 'mm', 'letter');

        //     var img_fondo = document.getElementById("logo_solarium");
        //     doc.addImage(img_fondo, 'JPEG', 15, 15, 75, 20)

        //     //grosor linea
        //     doc.setLineWidth(0.2);
        //     //horizontal lines
        //     doc.line(10, 10, 120, 10);
        //     doc.line(10, 40, 120, 40);
        //     //vertical lines
        //     doc.line(10, 9.5, 10, 40.5);
        //     doc.line(120, 9.5, 120, 40.5);

        //     // doc.setFont("arial", "bold");
        //     // doc.setFontSize(10);
        //     // doc.text('SOLARIUM CENTER SPA', 45, 15);
        //     // doc.setFont("arial", "NORMAL");
        //     // doc.setFontSize(8);
        //     // doc.text('RUT:', 45, 21);
        //     // doc.text('DIRECCION', 45, 26);
        //     // doc.text('COMUNA:', 80, 31);
        //     // doc.text('CIUDAD', 45, 31);
        //     // doc.text('TELEFONO:', 45, 36);

        //     doc.setFont("arial", "bold");
        //     doc.setFontSize(10);
        //     doc.text('RECIBO DE LIQUIDACIÓN', 145, 15);
        //     doc.setFont("arial", "NORMAL");
        //     doc.setFontSize(8);
        //     doc.text('PERIODO:', 150, 21);
        //     doc.text('' + this.mes + '-' + this.anio, 170, 21);

        //     doc.line(130, 30, 200, 30);
        //     doc.line(130, 40, 200, 40);
        //     //vertical lines
        //     doc.line(130, 30.5, 130, 40.5);
        //     doc.line(200, 30.5, 200, 40.5);

        //     doc.setFont("arial", "bold");
        //     doc.setFontSize(10);
        //     doc.text('NÚMERO:', 135, 36);
        //     doc.setFontSize(12);
        //     doc.text('' + this.numero_folio, 180, 36);

        //     doc.line(10, 45, 200, 45);
        //     doc.line(10, 65, 200, 65);
        //     //vertical lines
        //     doc.line(10, 45.5, 10, 65.5);
        //     doc.line(200, 45.5, 200, 65.5);

        //     //obtener datos del usuario
        //     doc.setFontSize(8);
        //     doc.text('PROFESIONAL', 15, 51);
        //     doc.text('ID USUARIO', 145, 51);
        //     doc.text('EMAIL', 15, 56);
        //     doc.text('USUARIO', 15, 61);
        //     doc.text('TIPO USUARIO', 80, 61);
        //     doc.text('COMISIÓN', 145, 61);

        //     const data_profe = this.myProfesional.filter(res => res.usuario == this.usuario);
        //     if(data_profe.length!=0){
        //         doc.setFontSize(9);
        //         doc.setFont("arial", "normal");
        //         doc.text(':  '+ data_profe[0].nombre, 37, 51);
        //         doc.text(':  '+ data_profe[0].ID, 175, 51);
        //         doc.text(':  '+ data_profe[0].email, 37, 56);
        //         doc.text(':  '+ data_profe[0].usuario, 37, 61);
        //         doc.text(':  '+ data_profe[0].tipo, 105, 61);
        //         doc.text(':  '+ data_profe[0].comision +'%', 175, 61);
        //     };

        //     doc.line(10, 70, 200, 70);
        //     doc.line(10, 75, 200, 75);
        //     doc.setFontSize(8);
        //     doc.setFont("arial", "bold");
        //     doc.text('FECHA', 10, 73.5);
        //     doc.text('CLIENTE', 30, 73.5);
        //     doc.text('PRODUCCIÓN', 100, 73.5, { align: "right" });
        //     doc.text('FORMA', 107, 73.5);
        //     doc.text('DESCUENTO', 150, 73.5, { align: "right" });
        //     doc.text('LIQUIDACION', 178, 73.5, { align: "right" });
        //     doc.text('PAGO 30%', 200, 73.5, { align: "right" });
            
        //     //Detalle
        //     let suma_total = 0;
        //     let line = 80;
        //     doc.setFont("arial", "normal");
        //     detail.forEach(element => {
        //         doc.text('' + element.Fecha, 10, line);
        //         doc.text('' + element.Cliente, 30, line);
        //         doc.text('' + new Intl.NumberFormat("de-DE").format(parseFloat(element.Total_Servicio)), 100, line, { align: "right" });
        //         doc.text('' + element.Forma, 107, line);
        //         doc.text('' + new Intl.NumberFormat("de-DE").format(parseFloat(element.Desc_Tarjeta)), 150, line, { align: "right" });
        //         doc.text('' + new Intl.NumberFormat("de-DE").format(parseFloat(element.Ingreso_Profesional)), 178, line, { align: "right" });
        //         doc.text('' + new Intl.NumberFormat("de-DE").format(parseFloat(element.Ingreso_Local)), 200, line, { align: "right" });
        //         suma_total = parseFloat(suma_total) + parseFloat(element.Ingreso_Profesional);
        //         line = line + 5;                
        //     });

        //     doc.line(10, 227, 200, 227);

        //     //horizontal lines
        //     doc.line(130, 230, 200, 230);
        //     doc.line(130, 246, 200, 246);
        //     //vertical lines
        //     doc.line(130, 230, 130, 246);
        //     doc.line(200, 230, 200, 246);

        //     //Total
        //     doc.setFont("arial", "bold");
        //     doc.setFontSize(10);
        //     doc.text('ANTICIPO', 135, 236);
        //     doc.setFontSize(9);
        //     doc.text('( $' + new Intl.NumberFormat("de-DE").format(parseFloat(this.total_anticipo)) +' )', 180, 236);
        //     doc.setFontSize(10);
        //     doc.text('TOTAL A PAGO', 135, 243);
        //     doc.setFontSize(12);
        //     doc.text('$' + new Intl.NumberFormat("de-DE").format(parseFloat(this.total_ingreso)), 180, 243);

        //     //Recibi conforme
        //     doc.setFont("arial", "normal");
        //     doc.setFontSize(8);
        //     doc.line(20, 260, 70, 260);
        //     doc.text('Recibí Conforme', 35, 265);

        //     doc.line(140, 260, 190, 260);
        //     doc.text('Solarium Spa', 160, 265);
            
        //     //doc.output('dataurlnewwindow')
        // },
        async search_number(){
            this.loading=true;
            if(this.numero!=null && this.numero!=''){
                if(parseInt(this.numero)!=0){
                    try {
                        const headers = {
                            'Content-Type': 'application/json',
                            'Authorization': 'Token ' + this.apikey
                        };
                        const params = {
                            'contrato' : this.contrato,
                            'user' : this.user,
                            'number' : this.numero
                        };
                        const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/number/liquida/',params,{headers});
                        const datos = res.data;
                        console.log('number liquida',datos);
                        if(datos[0].existe=='si'){
                            this.usuario = datos[0].Profesional;
                            const name_user = this.myProfesional.filter(res => res.usuario == this.usuario);
                            console.log('name_user',name_user)
                            if(name_user.length!=0){ this.nombre = name_user[0].nombre };
                            this.mes = datos[0].Mes;
                            this.anio = datos[0].Anio;
                            //buscar las ultimas 3 liquidaciones
                            //await this.search_liquidaciones(this.usuario);

                            //buscamos si tiene anticipos
                            await this.search_anticipos();
                            //buscar el detalle de la liquidacion
                            await this.filter_liquida();
                       } else {
                        this.color_snack='error';
                        this.mensaje='Número de liquidación no existe';
                        this.snack=true
                       }
                    } catch (error) {
                        console.log(error)
                    };
                    this.d_liquida=false
                } else {
                    this.color_snack='error';
                    this.mensaje='Ingrese número de liquidación';
                    this.snack=true
                }
            } else {
                this.color_snack='error';
                this.mensaje='Ingrese número de liquidación';
                this.snack=true
            };
            this.loading=false;
        },
        async filter_liquida(){
            if(this.usuario!=''){
                this.myServicios=[];
                try {
                    const headers = {
                        'Content-Type' : 'application/json',
                        'Authorization' : 'Token ' + this.apikey
                    };
                    const params = {
                        'contrato' : this.contrato,
                        'user' :  this.user,
                        'usuario' :  this.usuario,
                        'mes' :  this.mes,
                        'anio' :  this.anio,
                    };
                    const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/filter/liquida/',params,{headers});
                    const datos = res.data;
                    console.log('servicios', datos);
                    if(datos[0].existe=='si'){
                        this.disabled_data=true;
                        this.myServicios = datos;
                        //obtener el total del periodo
                        let suma_produccion = 0;
                        let suma_descuento = 0;
                        let suma_egreso = 0;
                        let suma_ingreso = 0;
                        datos.forEach(element => {
                            suma_produccion = parseFloat(suma_produccion) + parseFloat(element.Total_Servicio);
                            suma_descuento = parseFloat(suma_descuento) + parseFloat(element.Desc_Tarjeta);
                            suma_egreso = parseFloat(suma_egreso) + parseFloat(element.Ingreso_Local);
                            suma_ingreso = parseFloat(suma_ingreso) + parseFloat(element.Ingreso_Profesional);
                        });
                        //procesamos las ventas si existen
                        if(parseFloat(this.comision)!=0){
                            await this.search_ventas();
                            if(this.myVentas.length!=0){
                                this.myVentas.forEach(element => {
                                    const fecha_venta = element.Fecha;
                                    const sku_venta = element.Sku;
                                    const producto_venta = element.Producto;
                                    const total_venta = element.Total;
                                    const comision_venta = parseFloat(parseFloat(total_venta) * (parseFloat(this.comision)/100)).toFixed(0);
                                    const ingreso_venta = parseFloat(total_venta) - parseFloat(comision_venta);
                                    this.myServicios.push({
                                        'Fecha': fecha_venta,
                                        'Servicio': sku_venta,
                                        'Detalle': producto_venta,
                                        'Total_Servicio': total_venta,
                                        'Desc_Tarjeta': 0,
                                        'Ingreso_Local': ingreso_venta,
                                        'Ingreso_Profesional': comision_venta
                                    });
                                    suma_produccion = parseFloat(suma_produccion) + parseFloat(total_venta);
                                    //suma_descuento = parseFloat(suma_descuento) + parseFloat(element.Desc_Tarjeta);
                                    suma_egreso = parseFloat(suma_egreso) + parseFloat(ingreso_venta);
                                    suma_ingreso = parseFloat(suma_ingreso) + parseFloat(comision_venta);
                                });
                            }    
                        };
                        this.total_produccion = suma_produccion;
                        this.total_descuento = suma_descuento;
                        this.total_egreso = suma_egreso;
                        this.total_ingreso = parseFloat(suma_ingreso) - (parseFloat(this.total_anticipo));
                    } else {
                        this.color_snack='error';
                        this.mensaje='No existen servicios pendientes para el periodo';
                        this.snack=true
                    }
                } catch (error) {
                    console.log(error)
                }
            } else {
                this.color_snack='error';
                this.mensaje='Seleccione profesional para buscar servicios';
                this.snack=true
            }
        },
        async modifica_liquida(){
            this.loading=true;
            try {
                const headers = {
                    'Content-Type': 'application/json',
                    'Authorization': 'Token ' + this.apikey
                };
                const params = {
                    'contrato' : this.contrato,
                    'user' : this.user,
                    'number' : this.numero
                };
                const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/delete/liquida/',params,{headers});
                const datos = res.data;
                console.log('delete liquida',datos);
                if(datos[0].existe=='si'){
                    this.btn_venta=true;
                    this.color_snack='success';
                    this.mensaje='Liquidación anulada con exito';
                    this.snack=true;
                }               
            } catch (error) {
                console.log(error)
            };
            this.loading=false;
        },
        async folio_liquida(){
            let result = 0;
            const now = new Date();
            const data_now = now.getFullYear()+''+now.getMonth()+''+now.getDate()+''+now.getHours()+''+now.getMinutes()+''+now.getSeconds();
            try {
                const headers = {
                    'Content-Type': 'application/json',
                    'Authorization': 'Token ' + this.apikey
                };
                const params = {
                    'contrato' : this.contrato,
                    'user' : this.user,
                    'referencia' : data_now,
                };
                //grabar nuevo folio
                const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/save/folio/liquida/',params,{headers});
                const datos = res.data;
                if(datos[0].existe=='si'){
                    //obtener el folio grabado
                    const res1 = await axios.post(process.env.VUE_APP_URL + '/api/v1/get/folio/liquida/',params,{headers});
                    const datos1 = res1.data;
                    if(datos1[0].existe=='si'){
                        this.numero_folio=datos1[0].ID;
                        result = datos1[0].ID;
                    }
                }
            } catch (error) {
                console.log(error)
            };
            return result
        },
        async suma_ck(fila){
            fila.Estado='Recauda';
            this.array_recauda.push({
                id: fila.ID,
                profesional: fila.Profesional,
                comanda: fila.Comanda,
                monto: fila.Ingreso_Local
            });
            await this.calcula_recauda();
        },
        async resta_ck(fila){
            fila.Estado='Pendiente';
            this.array_recauda = this.array_recauda.filter(function(dat) {
                return dat.comanda !== fila.Comanda; 
            });
            await this.calcula_recauda();
        },
        async calcula_recauda(){
            let recauda = 0;
            if(this.array_recauda.length!=0){
                this.array_recauda.forEach(element => {
                    recauda = recauda + parseFloat(element.monto);
                });
            }
            this.total_recauda = recauda;
            this.txt_recauda = new Intl.NumberFormat("de-DE").format(parseFloat(this.total_recauda))
        },
        async pagar_recauda(){
            this.loading=true;
            if(this.array_recauda.length!=0){
                if(this.forma_recauda!=''){
                    for (let index = 0; index < this.array_recauda.length; index++) {
                        const element = this.array_recauda[index];
                        try {
                            const headers = {
                                'Content-Type': 'application/json',
                                'Authorization': 'Token ' + this.apikey
                            };
                            const params = {
                                'contrato' : this.contrato,
                                'user' : this.user,
                                'profesional': element.profesional,
                                'comanda': element.comanda,
                                'total': element.monto,
                                'forma': this.forma_recauda,
                                'observa': this.observa_recauda
                            }
                            const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/save/payment/',params,{headers});
                            const datos = res.data;
                            if(datos[0].existe=='si'){
                                console.log('pago registrado correctamente')
                            } else {
                                console.log('pago NO registrado')
                            }
                        } catch (error) {
                            console.log(error)
                        }
                        
                    };
                    //refrescamos la lista
                    await this.search_liquida();
                    //limpiamos la recaudacion
                    this.array_recauda=[];
                    this.total_recauda=0;
                    this.txt_recauda='0';
                    this.forma_recauda='';
                } else {
                    this.color_snack='error';
                    this.mensaje='Seleccione forma de pago';
                    this.snack=true;
                }
            };
            this.loading=false;
        },

        // nueva create liquidacion
        async create_PDF(){
            this.loading=true;
            try {
                //variables para el array_liquida
                let anticipo_total = 0;
                let total_servicios = 0;
                let cantidad_servicios = 0;
                let total_otros_MP = 0;
                let cantidad_otros_MP = 0;
                let total_cobro_directo = 0;
                let cantidad_cobro_directo = 0;
                let total_comisiones = 0;
                let total_pagar = 0;
                let array_liquida = [];
                const headers = {
                    'Content-Type': 'application/json',
                    'Authorization': 'Token ' + this.apikey
                };
                //buscar los anticipos de la liquidacion
                const par_anticipo = {
                    'contrato' : this.contrato,
                    'user' :  this.user,
                    'usuario' :  this.usuario,
                    'mes' :  this.mes,
                    'anio' :  this.anio,
                };
                const res_anticipo = await axios.post(process.env.VUE_APP_URL + '/api/v1/filter/anticipos/',par_anticipo,{headers});
                const data_anticipo = res_anticipo.data;
                if(data_anticipo[0].existe=='si'){
                    data_anticipo.forEach(element => {
                        anticipo_total = parseFloat(anticipo_total) + parseFloat(element.Monto);
                    });
                };
                //buscar servicios de la liquidacion
                const par = {
                    'contrato' : this.contrato,
                    'user' :  this.user,
                    'usuario' :  this.usuario,
                    'mes' :  this.mes,
                    'anio' :  this.anio,
                };
                const res_liq = await axios.post(process.env.VUE_APP_URL + '/api/v1/filter/liquida/',par,{headers});
                const data_liq = res_liq.data;
                if(data_liq[0].existe=='si'){
                    //obtener totales del encabezado
                    data_liq.forEach(element => {
                        total_servicios = parseFloat(total_servicios) + parseFloat(element.Total_Servicio);
                        cantidad_servicios = parseFloat(cantidad_servicios) + 1;
                        if(element.Forma=='Cobro Directo'){
                            cantidad_cobro_directo = parseFloat(cantidad_cobro_directo) + 1;
                            total_cobro_directo = parseFloat(total_cobro_directo) + parseFloat(element.Ingreso_Local);
                        } else {
                            cantidad_otros_MP = parseFloat(cantidad_otros_MP) + 1;
                            total_otros_MP = parseFloat(total_otros_MP) + parseFloat(element.Ingreso_Profesional);
                        }
                        total_comisiones = parseFloat(total_comisiones) + parseFloat(element.Ingreso_Profesional);
                    });
                    total_pagar = parseFloat(total_otros_MP) - parseFloat(anticipo_total);                    
                    //asignamos los datos en un array
                    array_liquida = [{
                        'id': this.numero_folio,
                        'profesional': this.usuario,
                        'mes': this.mes,
                        'anio': this.anio,
                        'periodo': this.mes + '-' + this.anio,
                        'total_servicios' : total_servicios,
                        'cantidad_servicios' : cantidad_servicios,
                        'total_otros_MP' : total_otros_MP,
                        'cantidad_otros_MP' : cantidad_otros_MP,
                        'total_cobro_directo' : total_cobro_directo,
                        'cantidad_cobro_directo' : cantidad_cobro_directo,
                        'total_comisiones' : total_comisiones,
                        'total_anticipo' : anticipo_total,
                        'total_pagar' : total_pagar
                    }];

                    //formateamos a 5 hojas
                    let hojas_array = [];
                    const datos_detail = data_liq;
                    if(datos_detail.length!=0){
                        const hoja0 = datos_detail.slice(0, 30)
                        hojas_array.push(hoja0);
                        const hoja1 = datos_detail.slice(30, 60)
                        hojas_array.push(hoja1);
                        const hoja2 = datos_detail.slice(60,90 )
                        hojas_array.push(hoja2);
                        const hoja3 = datos_detail.slice(90, 120)
                        hojas_array.push(hoja3);
                        const hoja4 = datos_detail.slice(120, 150)
                        hojas_array.push(hoja4);
                    };
                    //recorrer los array con datos
                    let numero_hoja = 0;
                    const doc = new jsPDF('p', 'mm', 'letter');
                    for (let index = 0; index < hojas_array.length; index++) {
                        const detail = hojas_array[index];
                        if(detail.length!=0){
                            numero_hoja = numero_hoja + 1;
                            if(parseInt(numero_hoja) != 1) {
                            doc.addPage('p','mm','letter');
                            } 
                            await this.PDF_liquida(doc, detail, array_liquida);
                        }
                    }
                    doc.output('dataurlnewwindow')
                }
            } catch (error) {
                console.log(error);
            }
            this.loading=false
        },
        async PDF_liquida(doc, detail, array_liquida){

            const head_venta = array_liquida[0];

            var img_fondo = document.getElementById("logo_solarium");
            doc.addImage(img_fondo, 'JPEG', 15, 15, 75, 20)

            //grosor linea
            doc.setLineWidth(0.2);
            //horizontal lines
            doc.line(10, 10, 120, 10);
            doc.line(10, 40, 120, 40);
            //vertical lines
            doc.line(10, 9.5, 10, 40.5);
            doc.line(120, 9.5, 120, 40.5);

            doc.setFont("arial", "bold");
            doc.setFontSize(10);
            doc.text('RECIBO DE LIQUIDACIÓN', 145, 15);
            doc.setFont("arial", "NORMAL");
            doc.setFontSize(8);
            doc.text('PERIODO :', 150, 21);
            doc.text('' + head_venta.periodo, 170, 21);

            doc.line(130, 30, 200, 30);
            doc.line(130, 40, 200, 40);
            //vertical lines
            doc.line(130, 30.5, 130, 40.5);
            doc.line(200, 30.5, 200, 40.5);

            doc.setFont("arial", "bold");
            doc.setFontSize(10);
            doc.text('NÚMERO:', 135, 36);
            doc.setFontSize(12);
            doc.text('' + head_venta.id, 180, 36);

            //vertical horizontales
            doc.line(10, 45, 200, 45);
            doc.line(10, 83, 200, 83);
            //vertical lines
            doc.line(10, 45.5, 10, 83.5);
            doc.line(200, 45.5, 200, 83.5);

            //encabezado
            doc.setFontSize(7);

            doc.text('PROFESIONAL', 15, 51);
            doc.text('PERIODO', 15, 56);
            doc.text('', 15, 61);
            doc.text('ANTICIPOS', 15, 66);
            doc.text('', 15, 71);
            doc.text('TOTAL A PAGAR', 15, 76);
            doc.text('', 15, 81);

            doc.text('TOTAL VALOR SERVICIO', 130, 51);
            doc.text('SERVICIOS REALIZADOS', 130, 56);
            doc.text('70% OTRO MP', 130, 61);
            doc.text('SERVICIOS OTROS MP', 130, 66);
            doc.text('30% COBRO DIRECTO', 130, 71);
            doc.text('SERVICIOS COBRO DIRECTO', 130, 76);
            doc.text('TOTAL COMISIÓN', 130, 81);

            doc.setFontSize(9);

            doc.text(':  '+ head_venta.profesional.toUpperCase(), 37, 51);
            doc.text(':  '+ head_venta.periodo, 37, 56);
            doc.text(':  '+ new Intl.NumberFormat("de-DE").format(parseFloat(head_venta.total_anticipo)), 37, 66);
            doc.text(':  '+ new Intl.NumberFormat("de-DE").format(parseFloat(head_venta.total_pagar)), 37, 76);
            
            doc.text(':  '+ new Intl.NumberFormat("de-DE").format(parseFloat(head_venta.total_servicios)), 170, 51);
            doc.text(':  '+ new Intl.NumberFormat("de-DE").format(parseFloat(head_venta.cantidad_servicios)), 170, 56);
            doc.text(':  '+ new Intl.NumberFormat("de-DE").format(parseFloat(head_venta.total_otros_MP)), 170, 61);
            doc.text(':  '+ new Intl.NumberFormat("de-DE").format(parseFloat(head_venta.cantidad_otros_MP)), 170, 66);
            doc.text(':  '+ new Intl.NumberFormat("de-DE").format(parseFloat(head_venta.total_cobro_directo)), 170, 71);
            doc.text(':  '+ new Intl.NumberFormat("de-DE").format(parseFloat(head_venta.cantidad_cobro_directo)), 170, 76);
            doc.text(':  '+ new Intl.NumberFormat("de-DE").format(parseFloat(head_venta.total_comisiones)), 170, 81);

            doc.line(10, 85, 200, 85);
            doc.line(10, 90, 200, 90);

            doc.setFontSize(8);
            
            doc.setFont("arial", "bold");
            doc.text('FECHA', 10, 88.5);
            doc.text('CLIENTE', 30, 88.5);
            doc.text('PRODUCCIÓN', 100, 88.5, { align: "right" });
            doc.text('FORMA', 107, 88.5);
            doc.text('DESCUENTO', 150, 88.5, { align: "right" });
            doc.text('LIQUIDACION', 178, 88.5, { align: "right" });
            doc.text('PAGO 30%', 200, 88.5, { align: "right" });
            
            //Detalle
            let line = 94;
            doc.setFont("arial", "normal");
            detail.forEach(element => {
                if(element.Servicio!='Solarium'){
                    doc.text('' + element.Fecha, 10, line);
                    doc.text('' + element.Cliente, 30, line);
                    doc.text('' + new Intl.NumberFormat("de-DE").format(parseFloat(element.Total_Servicio)), 100, line, { align: "right" });
                    doc.text('' + element.Forma, 107, line);
                    doc.text('' + new Intl.NumberFormat("de-DE").format(parseFloat(element.Desc_Tarjeta)), 150, line, { align: "right" });
                    doc.text('' + new Intl.NumberFormat("de-DE").format(parseFloat(element.Ingreso_Profesional)), 178, line, { align: "right" });
                    doc.text('' + new Intl.NumberFormat("de-DE").format(parseFloat(element.Ingreso_Local)), 200, line, { align: "right" });
                    //suma_total = parseFloat(suma_total) + parseFloat(element.Ingreso_Profesional);
                    line = line + 5;
                }
            });

            //******************************************************************************************************
            //*                     no corresponde para este negocio, las ventas son directas del local            *
            //******************************************************************************************************

            // //buscar el ventas de la liquidacion
            // const parametros = {
            //     'contrato' : this.contrato,
            //     'user' :  this.user,
            //     'usuario' :  head_venta.Profesional,
            //     'mes' :  head_venta.Mes,
            //     'anio' :  head_venta.Anio,
            // };
            // const res_venta = await axios.post(process.env.VUE_APP_URL + '/api/v1/filter/ventas/',parametros,{headers});
            // const data_venta = res_venta.data;
            // console.log('data_venta',data_venta)
            // if(data_venta[0].existe=='si'){
            //     data_venta.forEach(element => {
            //         const total_venta = element.Total;
            //         const comision_venta = parseFloat(parseFloat(total_venta) * (parseFloat(comision_user)/100)).toFixed(0);
            //         doc.text('' + element.Fecha, 10, line);
            //         doc.text('' + 'Sku: ' + element.Sku, 30, line);
            //         doc.text('' + new Intl.NumberFormat("de-DE").format(parseFloat(total_venta)), 100, line, { align: "right" });
            //         doc.text('' + 'Comisión ' + comision_user + '%', 107, line);
            //         doc.text('' + '0', 150, line, { align: "right" });
            //         doc.text('' + new Intl.NumberFormat("de-DE").format(parseFloat(comision_venta)), 178, line, { align: "right" });
            //         doc.text('' + '0', 200, line, { align: "right" });
            //         suma_total = parseFloat(suma_total) + parseFloat(comision_venta);
            //         line = line + 5;                
            //     });
            // }                

            //******************************************************************************************************
            //******************************************************************************************************


            doc.line(10, 242, 200, 242);

            //Recibi conforme
            doc.setFont("arial", "normal");
            doc.setFontSize(8);
            doc.line(20, 260, 70, 260);
            doc.text('Recibí Conforme', 35, 265);

            doc.line(140, 260, 190, 260);
            doc.text('Solarium Spa', 160, 265);

            
            //doc.output('dataurlnewwindow');
        },



    }

}
</script>
